import { ca } from '@cian/analytics';

interface ITrackClickCardParams {
  sc: object;
  products: unknown;
  page: Record<string, unknown>;
}

export function trackNewbuildingLinkClick({ sc, products, page }: ITrackClickCardParams) {
  ca('eventSite', {
    action: 'to_card_newbuilding',
    category: 'Listing',
    label: 'from_listing_in_map',
    name: 'oldevent',
    sc,
    products,
    page,
  });
}
